import fileType from 'file-type'
import { NotSupported } from '@/errors'
import Vue from 'vue'

function randomId (excludeList) {
  function createId () {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10)
  }
  let id = createId()
  while (excludeList.indexOf(id) > -1 || id.length < 8) {
    id = createId()
  }
  return id
}

function getStoreFromVnode (store, vnode) {
  return store.getters.modulesByPath[vnode.componentOptions.propsData.path]
}

// add unsupported mimetypes here
const unsupportedMimetypes = []

async function guessMimetype (buffer) {
  const type = await fileType.fromBuffer(buffer)
  const mime = type && type.mime
  if (unsupportedMimetypes.includes(mime)) {
    throw new NotSupported('Mimetype')
  }
  return mime
}

function deepMerge (state, value, propName) {
  if (
    Object.prototype.toString.call(value) === '[object Object]' &&
    (propName == null || Object.prototype.hasOwnProperty.call(state, propName))
  ) {
    const o = propName == null ? state : state[propName]
    for (var prop in value) {
      deepMerge(o, value[prop], prop)
    }
    return
  }
  if (value !== null) Vue.set(state, propName, value)
}

function cleanTree (state) {
  for (var prop in state) {
    if (!prop.startsWith('_')) {
      if (state._children.indexOf(prop) === -1) {
        Vue.delete(state, prop)
      }
      if (Object.prototype.toString.call(state[prop]) === '[object Object]') {
        cleanTree(state[prop])
      }
    }
  }
}

export { randomId, guessMimetype, getStoreFromVnode, deepMerge, cleanTree }
